import React from 'react';
import {
	TouchableOpacity,
	TouchableWithoutFeedback,
	TouchableOpacityProps,
	TouchableWithoutFeedbackProps,
	Platform,
} from 'react-native';

class TouchableWrapper extends React.Component<TouchableWithoutFeedbackProps & TouchableOpacityProps> {
	render(): JSX.Element {
		return Platform.OS == 'android' ? (
			<TouchableOpacity {...this.props}>{this.props.children}</TouchableOpacity>
		) : (
			<TouchableWithoutFeedback {...this.props}>{this.props.children}</TouchableWithoutFeedback>
		);
	}
}

export default TouchableWrapper;
